// extracted by mini-css-extract-plugin
module.exports = {"replyButton":"ip3HT","reply":"_3aeuc","replyIcon":"_1h4Hs"};